import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'dp-svg',
  templateUrl: './svg.component.html',
  styleUrls: ['./svg.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SvgComponent {
  @Input() src: string;
  @Input() w;
  @Input() h;
  @Input() color;
  svgAttributes;

  ngOnInit() {
    this.svgAttributes = {
      width: this.w || 24,
      height: this.h || 24,
      fill: this.color || '#000000',
    };
  }
}
